module.exports = __webpack_public_path__ + "static/media/country_codes_dialing_A2_A3_M49.cacf81c2.csv";